// src/hooks/useRoleAccess.js
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { CenterContext } from '../context/CenterContext';

const useRoleAccess = () => {
  const { currentUser } = useContext(UserContext);
  const { currentCenter } = useContext(CenterContext);

  const role = currentUser?.role;
  const centerFeatures = currentCenter?.features || [];

  const isAdmin = role === 'admin';
  const isStaff = role === 'staff';
  const isParent = role === 'parent';

  const canUseFeature = (featureName) =>
    isAdmin || centerFeatures.includes(featureName);

  const canSendMessages = isAdmin || isStaff;
  const canUseChat = canUseFeature('chat');
  const canViewReports = isAdmin;
  const canManageBilling = isAdmin;
  const canSubmitForms = isStaff || isParent;
  const canUploadAvatar = true;

  return {
    isAdmin,
    isStaff,
    isParent,
    canUseFeature,
    canSendMessages,
    canUseChat,
    canViewReports,
    canManageBilling,
    canSubmitForms,
    canUploadAvatar, // 👈 new capability

  };
};

export default useRoleAccess;
